module.exports = __webpack_public_path__ + "static/img/9.6c3bec44.jpg";